<template>
  <div class="container py-10 mx-auto px-1 sm:px-0">
    <h3>FAQs</h3>

    <div class="mt-3 space-y-4">
      <details class="border-b pb-3">
        <summary class="cursor-pointer font-semibold">Our Services</summary>
        <div class="mt-2 space-y-1"><!-- NEW -->
          <div>Basically, there are three main ways to sell your Magic cards:</div>
          <div class="pl-4">Standard Service:</div>
          <div class="pl-8">Just pack 'em up and ship 'em (up to 2,500 cards).</div>
          <div class="pl-8">We’ll sort, value, and pay you.</div>
          <div class="pl-8">It costs 10% of the value plus $0.03 per card.</div>
          <div class="pl-8">Tip: Don't send in super cheap cards or basic lands – it's probably not worth it!</div>
        </div>
      </details>

      <details class="border-b pb-3">
        <summary class="cursor-pointer font-semibold">Shipping Cards</summary>
        <p class="mt-2">To be populated...</p>
      </details>

      <details class="border-b pb-3">
        <summary class="cursor-pointer font-semibold">Payment</summary>
        <p class="mt-2">To be populated...</p>
      </details>

      <details class="border-b pb-3">
        <summary class="cursor-pointer font-semibold">Fees</summary>
        <p class="mt-2">To be populated...</p>
      </details>

      <details class="border-b pb-3">
        <summary class="cursor-pointer font-semibold">Valuation</summary>
        <p class="mt-2">To be populated...</p>
      </details>

      <details class="border-b pb-3">
        <summary class="cursor-pointer font-semibold">Miscellaneous</summary>
        <p class="mt-2">To be populated...</p>
      </details>



      <!-- Add more Q&A blocks as needed -->
    </div>
  </div>
</template>

<script setup>
// no script needed yet
</script>
